export default __webpack_public_path__ + "static/media/priestofmitrahead.b831a953.png";